import ApiService from '@/services/ApiService'

const REPOSITORY_URL = 'plazofijo'

const PlazoFijoRepository = {
  detalle(idPlazoFijo) {
    let data = {
      idPlazoFijo,
    }
    return ApiService.get(`${REPOSITORY_URL}/detalle`,data)
  },
}

export default PlazoFijoRepository
